import Repository from "../Repository";
const createWebsiteRole = "create";
const getWebsiteRole = "getWebsiteRole";
const deleteWebsiteRole = "deleteWebsiteRole";
const updateWebsiteRole = "updateWebsiteRole";

export default {
  create(payload) {
    return Repository.post(transformRoute(createWebsiteRole), payload);
  },

  get(payload) {
    return Repository.post(transformRoute(getWebsiteRole), payload);
  },

  update(payload) {
    return Repository.post(transformRoute(updateWebsiteRole), payload);
  },

  delete(payload) {
    return Repository.post(transformRoute(deleteWebsiteRole), payload);
  },
};

const transformRoute = (route) => {
  return `/websiteRoles/${route}`;
};
